export default {
  setLoading(state, value) {
    state.isLoading = value;
  },
  setData(state, {
    data,
    meta,
  }) {
    state.data = data;
    state.meta = meta;
  },
  setMeasureData(state, {
    data,
    meta,
  }) {
    state.measureData = data;
    state.measureMeta = meta;
  },
  setError(state, value) {
    state.hasError = value;
  },
};
